module.exports = __webpack_public_path__ + "img/mevioColor.5c2c68a4.png";